import { render, staticRenderFns } from "./manageNotification.vue?vue&type=template&id=10b2aa75"
import script from "./manageNotification.vue?vue&type=script&lang=js"
export * from "./manageNotification.vue?vue&type=script&lang=js"
import style0 from "./manageNotification.vue?vue&type=style&index=0&id=10b2aa75&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports